import { NavLink } from "react-router-dom";
import Loader from "../../utils/Loader";
import { useState } from "react";
import { useTheme } from "./context/ThemeContext";

function IconSun() {
   return (
      <svg
         viewBox="0 0 24 24"
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="2"
         strokeLinecap="round"
         aria-hidden
      >
         <circle cx="12" cy="12" r="4" />
         <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
      </svg>
   );
}

function IconMoon() {
   return (
      <svg
         viewBox="0 0 24 24"
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
         aria-hidden
      >
         <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
   );
}

function Navbar() {
  const [isDownloading, setIsDownloading] = useState(false);
  const { theme, toggleTheme } = useTheme();

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const fileName = "SunilRawatResume2025.pdf";
      const response = await fetch(
        `${process.env.REACT_APP_SIGNED_API_URL}?fileName=${fileName}`
      );

      const data = await response.json()
      const signedUrl = await data.result;
      const fileResponse = await fetch(signedUrl);
      console.log("fileResponse", fileResponse);

      if (!fileResponse.ok) {
        throw new Error(`File download failed with status ${fileResponse.status}`);
      }

      const blob = await fileResponse.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    setIsDownloading(false);
  };
  return (
    <header className="header">
      <div className="header-info">
        <img src="/me.ico" alt="{me}" className="nav-profile-image" />
        <button type="button" id="download-button" onClick={handleDownload}>
          {isDownloading ? (
            <Loader isLoading={isDownloading} />
          ) : (
            <>
              <span id="download-text">Resume</span>
              <img
                alt="{download resume}"
                id="download-icon"
                src="/images/download.png"
              />
            </>
          )}
        </button>
      </div>
      <nav className="navbar">
        <ul className="navbar_items">
          <li className="navbar_item">
            <NavLink to="/about">About</NavLink>
          </li>
          <li className="navbar_item">
            <NavLink to="/contact">Contact</NavLink>
          </li>
          <li className="navbar_item navbar_item-pro">
            <NavLink to="/projects">Projects</NavLink>
          </li>
          <li className="navbar_item">
            <button
              type="button"
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label={
                theme === "light" ? "Switch to dark mode" : "Switch to light mode"
              }
            >
              {theme === "light" ? <IconSun /> : <IconMoon />}
            </button>
          </li>

        </ul>
      </nav>
    </header>
  );
}
export default Navbar;
